export interface Validation {
  hasError?: boolean,
  message?: string
}
